import React, { useEffect } from "react";
import SecondContainer from "../../components/container/SecondContainer";
import { useAuthorization } from "../../hooks/useAuthorization";
import { useDispatch, useSelector } from "react-redux";
import { getAssigneeProjects, getProjects } from "../../features/projectsSlice";
import PaginationBar from "../../components/pagination/PaginationBar";
import Loading from "../../components/loading/Loading";
import { Link, useLocation } from "react-router-dom";
import PageTitle from "../../components/titles/PageTitle";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";

const ProjectImplementation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const projects = useSelector((state) => state.projects.data); // List of ongoing projects
  const total = useSelector((state) => state.projects.total);

  const user = useSelector((state) => state.user.userInfo); // List of ongoing projects
  const loading = useSelector(
    (state) => state.projects.load.getProjectRequests
  );

  const onPageChange = async (limit, offset) => {
    try {
      const res = await dispatch(getAssigneeProjects({ limit, offset }));
    } catch (error) {}
  };

  useEffect(() => {
    dispatch(getAssigneeProjects());
  }, []);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <SecondContainer className="  ">
      <PageTitle title="Implementation" />
      {/* Basic Instructions */}
      {/* <h1 className="text-2xl text font-bold mb-4">Ongoing Applications</h1> */}
      {/* <p className="mb-4 text-text-1/65">
    Below is a list of all ongoing applications. You can view the details of
    each project, see the current step, and continue your application. To
    start a new application, click the "New Application" button.
  </p> */}

      {/* Ongoing Applications Table */}

      <>
        <PaginationSecondBar
          loading={loading}
          onPageChange={onPageChange}
          total={total}
        />
        <div className="table-container">
          <table className="app-table">
            <thead className=" app-thead">
              <tr>
                <th className="app-thead-th">Num</th>
                <th className="app-thead-th">Title</th>
                <th className="app-thead-th">Last Saved</th>
                <th className="app-thead-th">Status</th>
                {/* {isAuthorized("pdo_department", "update") && ( */}
                <th className="app-thead-th">Action</th>
                {/* )} */}
              </tr>
            </thead>
            {loading ? (
              <tr className="!border-none !bg-transparent">
                <td colSpan={5} className="!border-none !border-transparent ">
                  <div className="h-72 flex items-center justify-center mx-auto w-fit !border-none">
                    <Loading />
                  </div>
                </td>
              </tr>
            ) : projects.length > 0 ? (
              <tbody className="text-text-1/85">
                {projects.map((project, index) => (
                  <tr key={project.id}>
                    {/* Project Num */}
                    <td className="table-data !text-sm">{++index}</td>
                    {/* Project Title */}
                    <td className="table-data !text-base">
                      {project.name.length >= 30
                        ? project.name.slice(0, 35) + "....."
                        : project.name}
                    </td>

                    {/* Date Started */}
                    <td className="table-data !text-sm">
                      {new Date(project.updated_at).toDateString()}
                    </td>

                    {/* Step Reached (Assumed it's available in the project object) */}
                    <td className="table-data !text-sm">
                      {project.stage.step || "Not Started"}
                    </td>

                    {/* Continue Application Button */}
                    {/* {isAuthorized("pdo_department", "update") && ( */}
                    <td className="table-data !text-sm text-center">
                      {project.stage?.desk ? (
                        <Link to={"/projects/implementation/" + project.id}>
                          <button className="px-4 py-2 bg-green-500/80 text-text-gen rounded hover:bg-green-600">
                            Cont. Implement
                          </button>
                        </Link>
                      ) : (
                        <p className="inline-block px-4 py-2 bg-slate-400 text-text-gen rounded ">
                          Pending Approval
                        </p>
                      )}
                    </td>
                    {/* )} */}
                  </tr>
                ))}
              </tbody>
            ) : (
              <>
                <tr className="!border-none !bg-transparent">
                  <td colSpan={6} className="!border-none !border-transparent ">
                    <div className="flex items-center justify-center w-full h-72 border border-bkg2 rounded-md">
                      <p className="text-text-1/60">
                        No ongoing Proposals found.
                      </p>
                    </div>
                  </td>
                </tr>
              </>
            )}
          </table>
        </div>
      </>
    </SecondContainer>
  );
};

export default ProjectImplementation;
